import { ONLINE_STATUS_THRESHOLD_MS } from "../variables/common";

export const isNetworkHealthOnline = (lastAlive: number): boolean => {
  const currentTime = new Date().getTime();
  const timeSincePrevLastAlive = currentTime - lastAlive;

  return timeSincePrevLastAlive < ONLINE_STATUS_THRESHOLD_MS;
};
